/* VPV Logo Marquee — bulletproof seamless fill + consistent speed.

   The track holds two identical groups; CSS animates translateX(0 → -50%) so the
   loop is seamless. To stay gapless when there are FEW logos, this clones the
   logo set within each group until each group is at least as wide as the
   viewport. It also sets a content-width-based duration so the perceived speed
   (px/sec) is consistent no matter how many logos there are.

   Honors prefers-reduced-motion: skips cloning (the CSS disables the animation
   and shows a single static, centered set). Idempotent — clears its own clones
   first, so it's safe to re-run on resize / shopify:section:load. */
(function () {
  var SPEED_PX_PER_SEC = { slow: 40, medium: 70, fast: 120 };
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function setup(root) {
    var track = root.querySelector('[data-lm-track]');
    if (!track) return;
    var groups = track.querySelectorAll('[data-lm-group]');
    if (groups.length < 2) return;
    var viewport = root.querySelector('.vpv-logo-marquee__viewport');
    if (!viewport) return;

    // Clear clones from any previous run (resize / re-init).
    groups.forEach(function (g) {
      g.querySelectorAll('[data-lm-clone]').forEach(function (n) { n.remove(); });
    });

    // Reduced motion → static single set; no clones, animation off in CSS.
    if (reduceMotion.matches) return;

    var vw = viewport.clientWidth;
    if (!vw) return;

    groups.forEach(function (group) {
      var base = Array.prototype.slice.call(group.children);
      if (!base.length) return;
      var guard = 0;
      while (group.scrollWidth < vw && guard < 60) {
        base.forEach(function (node) {
          var clone = node.cloneNode(true);
          clone.setAttribute('data-lm-clone', '');
          clone.setAttribute('aria-hidden', 'true');
          clone.removeAttribute('id');
          // Strip Shopify editor attrs so clones aren't treated as real blocks.
          Array.prototype.slice.call(clone.attributes).forEach(function (a) {
            if (a.name.indexOf('data-shopify') === 0) clone.removeAttribute(a.name);
          });
          group.appendChild(clone);
        });
        guard++;
      }
    });

    // Consistent speed: duration = one group's width / px-per-sec.
    var speed = root.getAttribute('data-speed') || 'medium';
    var pps = SPEED_PX_PER_SEC[speed] || SPEED_PX_PER_SEC.medium;
    var groupWidth = groups[0].scrollWidth;
    if (groupWidth > 0) {
      root.style.setProperty('--lm-duration', (groupWidth / pps).toFixed(2) + 's');
    }
  }

  function setupAll(scope) {
    (scope || document).querySelectorAll('[data-vpv-logo-marquee]').forEach(setup);
  }

  function onReady() {
    setupAll(document);
    // Image widths affect the measurement; recompute once everything has loaded.
    window.addEventListener('load', function () { setupAll(document); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () { setupAll(document); }, 150);
  });

  document.addEventListener('shopify:section:load', function (e) { setupAll(e.target); });
  if (reduceMotion.addEventListener) {
    reduceMotion.addEventListener('change', function () { setupAll(document); });
  }
})();
